// get single product by id
export const GET_PRODUCT_PROCESS = "GET_PRODUCT_PROCESS";
export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS";

// get all products
export const GET_PRODUCTS_PROCESS = "GET_PRODUCT_PROCESS";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCT_SUCCESS";

// Get products by category
export const GET_PRODUCTS_BY_CATEGORY_PROCESS =
  "GET_PRODUCTS_BY_CATEGORY_PROCESS";
export const GET_PRODUCTS_BY_CATEGORY_SUCCESS =
  "GET_PRODUCTS_BY_CATEGORY_SUCCESS";

// search a product by name and filter it by rating and price
export const SEARCH_RESULT_PROCESS = "SEARCH_RESULT_PROCESS ";
export const SEARCH_RESULT_SUCCESS = "SEARCH_RESULT_SUCCESS ";

// return the value of product title as a search result on input
export const INPUT_RESULT_PROCESS = "INPUT_RESULT_PROCESS ";
export const INPUT_RESULT_SUCCESS = "INPUT_RESULT_SUCCESS ";
